import React from 'react';
import { useIntl } from 'react-intl';
import { ScreeningModuleStore } from 'Core_Pages/Screening/ScreeningModuleStore';
import ResultsSymptom from 'Core_Pages/Screening/Results/components/ResultsSymptom/ResultsSymptom';
import { Screenings } from 'Core_Pages/Screening/enumerations/enums';
import SymptomWrapper from 'Core_Pages/Screening/Results/components/ResultsSymptom/SymptomWrapper';

const screeningGuid = Screenings.ADULT_EPDS;

const ResultsBody = () => {
  const intl = useIntl();
  const screeningStore = ScreeningModuleStore.Instance().Use();
  const result = screeningStore.ScreeningResults.find((x) => x.screeningGuid === screeningGuid);

  const symptomIsUrgent = () => {
    return result?.hasUrgentNeed;
  };

  return (
    <SymptomWrapper>
      <ResultsSymptom
        title={intl.formatMessage({ id: 'screenings.results.adult.epds.symptoms.additional_support' })}
        value={symptomIsUrgent()}
      />
    </SymptomWrapper>
  );
};

export default ResultsBody;
